module.exports = __webpack_public_path__ + "img/map_5.9daf7213.png";